export default __webpack_public_path__ + "static/media/spin-wheel-hit-win.da23870c.wav";